import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

import { IS_WEBAPP } from "@bryq/employers-src/settings";

export default class extends Controller {
  static targets = [
    "positionSelect",
    "departmentSelect",
    "segmentSelect",
    "submitButton",
  ];

  static classes = ["hidden", "select"];

  submitButtonTargetConnected(target) {
    target.classList.add(this.hiddenClass);
  }

  positionSelectTargetConnected(target) {
    // Marks the first option as the placeholder.
    // eslint-disable-next-line no-param-reassign
    target.querySelector("option:first-child").dataset.placeholder = "true";

    this.positionSelect = new SlimSelect({
      select: target,
      settings: { allowDeselect: true, showSearch: true },
    });
  }

  // eslint-disable-next-line no-unused-vars
  positionSelectTargetDisconnected(target) {
    if (this.positionSelect) {
      this.positionSelect.destroy();
    }
  }

  departmentSelectTargetConnected(target) {
    // Marks the first option as the placeholder.
    // eslint-disable-next-line no-param-reassign
    target.querySelector("option:first-child").dataset.placeholder = "true";

    this.departmentSelect = new SlimSelect({
      select: target,
      settings: { allowDeselect: true, showSearch: true },
    });
  }

  // eslint-disable-next-line no-unused-vars
  departmentSelectTargetDisconnected(target) {
    if (this.departmentSelect) {
      this.departmentSelect.destroy();
    }
  }

  segmentSelectTargetConnected(target) {
    // Marks the first option as the placeholder.
    // eslint-disable-next-line no-param-reassign
    target.querySelector("option:first-child").dataset.placeholder = "true";

    this.segmentSelect = new SlimSelect({
      select: target,
      settings: { allowDeselect: true, showSearch: true },
    });
  }

  // eslint-disable-next-line no-unused-vars
  segmentSelectTargetDisconnected(target) {
    if (this.segmentSelect) {
      this.segmentSelect.destroy();
    }
  }

  submit(event) {
    /**
     * Hack to make the filters propagate to the webapp URL. To be removed when
     * the webapp is retired.
     */
    if (IS_WEBAPP) {
      event?.preventDefault();

      const { __reactRouter: reactRouter } = window;

      const { href } = window.location;
      const url = new URL(href);
      url.search = new URLSearchParams(new FormData(this.element)).toString();
      const to = url.href.replace(url.origin, "");

      // Prevents the router from navigating to the same page multiple times in
      // case the user clicks the submit button multiple times.
      const currentTo = `${reactRouter.state.location.pathname}${reactRouter.state.location.search}`;
      if (currentTo !== to) {
        reactRouter.navigate(to);
      }

      return;
    }
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.click();
    }
  }
}
